import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { RouteComponentProps } from "react-router-dom";
import { useToast } from "hooks";

import { Session } from "types";
import { fetchSession, completeSession } from "api/webservice/sessions";
import { Button, Center, Flex, Heading, Text, VStack } from "@chakra-ui/react"
import { useCompleteSession } from "repo/sessions";

interface Props {
  sessionId: string;
}

const SessionCompletionScreen: React.FC<RouteComponentProps<Props>> = ({
  match
}: RouteComponentProps<Props>) => {
  const { sessionId } = match.params;
  const [session, setSession] = useState<Session>();
  const history = useHistory();
  const toast = useToast();
  const completeSessionMutation = useCompleteSession();

  const handleFetchSession = () => {
    fetchSession({ id: sessionId }).then(session => setSession(session));
  };

  useEffect(() => {
    handleFetchSession();
  }, [setSession]);

  if (!session) return null;


  const handleCompleteSession = (): void => {
    const onSettled = handleEndCall;
    const onError = (err: any, session: Session, context: any) => {
      toast({
        title: "Failed to complete session",
        description: err.response.data.response,
        status: "error"
      });
      handleEndCall();
    }

    completeSessionMutation.mutate(session, { onSettled, onError });

    ////need to call the api to complete the session
    //completeSession({ ...session })
    //  .then(() => {
    //    handleEndCall();
    //  })
    //  .catch(err =>
    //    toast({
    //      title: "Failed to complete session",
    //      description: err.response.data.response,
    //      status: "error"
    //    }));
    //handleEndCall();
  };

  const handleEndCall = (): void => {
    history.push("/dashboard");
  };

  const openSupportPopup = (): void => {
    console.log("support popup called");
    //taken from auto click-through question on jira community post
    //gets the iframe on which the widget is embedded
    const iframe = document.getElementById('jsd-widget') as HTMLObjectElement;
    //gets the content of the iframe
    const iframeContent = iframe!.contentDocument;
    //gets button which opens the widget
    const button = iframeContent!.querySelector('#help-button') as HTMLElement;
    if (button) {
      button.click();
    }
  }

  return (
    <>
      <Flex alignContent="center" justifyContent="center" height="100vh">
        <Center>
          <VStack>
            <Heading fontSize="55px" fontWeight="600">
              This call has ended.
            </Heading>
            <Heading fontSize="25px" fontWeight="300" pb="30px">
              Mark this session complete to return to your dashboard.
            </Heading>
            <Button size="sm" onClick={handleCompleteSession} variant="blue" width="352px" height="46px" borderRadius="26.5px">
              <Text fontSize="20px" fontWeight="600">
                Mark Session Complete
              </Text>
            </Button>
            <Button size="sm" onClick={handleEndCall} variant="outline" width="352px" height="46px" borderRadius="26.5px">
              <Text fontSize="20px" fontWeight="600">
                Return to Dashboard
              </Text>
            </Button>
            <Text as="u" fontSize="16px" fontWeight="300" onClick={openSupportPopup}>
              Let us know if you had technical issues.
            </Text>
          </VStack>
        </Center>
      </Flex>
    </>
  );
}

export default SessionCompletionScreen;
